import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Spinner, money } from "@/components/ui";

export default function PayRedirect() {
  const { slug } = useParams();
  const [state, setState] = useState({ loading: true, message: null, info: null });

  useEffect(() => {
    let cancelled = false;
    api.get(`/pay/${slug}`)
      .then((res) => {
        if (cancelled) return;
        if (res.data.stripe_url) {
          window.location.replace(res.data.stripe_url);
        } else {
          setState({ loading: false, message: res.data.message || "This link is no longer active.", info: res.data });
        }
      })
      .catch((e) => {
        if (!cancelled) setState({ loading: false, message: formatApiError(e), info: null });
      });
    return () => { cancelled = true; };
  }, [slug]);

  return (
    <div className="min-h-screen brand-glow flex items-center justify-center px-4">
      <div className="text-center max-w-sm">
        <div className="text-xl font-bold tracking-tight mb-6">
          Averoan <span className="text-primary">Technologies</span>
        </div>
        {state.loading ? (
          <>
            <div className="flex justify-center text-primary mb-4"><Spinner className="h-6 w-6" /></div>
            <p className="text-muted-foreground">Taking you to secure checkout…</p>
          </>
        ) : (
          <>
            <p className="text-lg">{state.message}</p>
            {state.info?.customer_name && (
              <p className="mt-2 text-sm text-muted-foreground">
                {state.info.customer_name}
                {state.info.one_time_total_cents ? ` · ${money(state.info.one_time_total_cents, state.info.currency)}` : ""}
              </p>
            )}
            <p className="mt-6 text-xs text-muted-foreground">
              Questions? Email <a className="text-primary" href="mailto:info@averoan.com">info@averoan.com</a>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
